// extracted by mini-css-extract-plugin
export default {"h2":"GH4xlKDv3q_rYataos-43","modal":"_1GKDL8ecFnSt8AwkSXGSHg","bold":"_1xZP_l-W8-8TqZhfRQzJd-"};